<template>
  <v-layout wrap v-if="content">
    <v-flex xs12 style="padding: 10px 0 20px 0;">
      <translate
        v-model="content.QAndAQuestion"
        :languages="languages"
        :label="$t('qAndA.question')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
      />
    </v-flex>
    <v-flex xs12>
      <small>
        {{$t('qAndA.answer')}}:
      </small>
      <translate
        type="richText"
        v-model="content.QAndAAnswer"
        :languages="languages"
        :label="$t('qAndA.answer')"
        @input="handleChangeIsModified"
        style="padding: 0 10px 0 10px;"
      />
    </v-flex>
  </v-layout>
</template>
<script>
  import { mapState } from 'vuex'
  import Translate from '@/components/Translate'
  export default {
    name: 'Form16Text',
    components: {
      Translate
    },
    props: {
      editedItem: {
        type: Object,
        required: true
      },
      onChangeIsModified: {
        type: Function,
        required: true,
      },
      config: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      content: null,
    }),
    computed: {        
      ...mapState('app', ['locale']),
      languages () {
        return this.config.Languages
      },
    },
    watch: {
      editedItem () {
        this.prepareContent()
      },
    },
    mounted () {
      this.prepareContent()
    },
    methods: {
      checkJSON (v) {
        return typeof v == 'object' ? v : JSON.parse(v)
      },
      prepareContent () {
        const aux = this.editedItem
        aux.QAndAQuestion = this.checkJSON(aux.QAndAQuestion)
        aux.QAndAAnswer = this.checkJSON(aux.QAndAAnswer)
        this.content = aux
      },
      handleChangeIsModified () {
        this.onChangeIsModified(this.content) 
      },
    },
  }
</script>

